module.exports = __webpack_public_path__ + "img/user_accounts_and_data_management.55b0448a.svg";